<template>
    <div class="page-content">

        <div id="soundlist" class="section grow bg-svg-dunes">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Wake up refreshed with Sleep Jar alarm tones.</h1>

                        <p class="lead mb-5">"<span class="underline">Alexa, wake me up to <b>rain sounds</b> alarm tone</span>"</p>

                        <div class="col-sm-12 ml-auto mr-auto mb-15">
                            <div class="row">
                                <media-item v-for="(item, itemKey, index) in media"
                                    v-bind:emitConfig="alarms_emit_config"
                                    v-bind:item="item"
                                    v-bind:key="itemKey"
                                    v-bind:index="index"
                                    v-bind:itemKey="itemKey"
                                    v-bind:platform="'alexa'"
                                    v-bind:type="'alarm'"
                                    ref="alarm-previews"
                                />
                            </div>
                        </div>

                        <div class="jumbotron">
                        <p class="lead"><b>Need some extra noise to wake up? Upgrade to a Premium Alarm Pack!</b></p>
                        <p class="lead">Each premium alarm pack unlocks 7 alarm patterns/melodies mixed with one of our sleep sounds.</p>
                        <p class="lead mb-5">Here's a demo of what each premium alarm sounds like in our <i>Premium Bird Sounds Alarms</i> pack:</p>

                        <div class="col-sm-12 ml-auto mr-auto mb-5">
                            <div class="row">
                                <media-item v-for="(item, index) in premium_alarms"
                                    v-bind:emitConfig="premium_alarms_emit_config"
                                    v-bind:buttonAlignment="'center'"
                                    v-bind:item="item"
                                    v-bind:itemKey="item.id"
                                    v-bind:index="index"
                                    v-bind:key="item.id"
                                    v-bind:platform="'alexa'"
                                    v-bind:type="'alarm'"
                                    v-bind:subtype="'premium'"
                                    ref="premium-alarm-previews"
                                />
                            </div>
                        </div>

                        <p class="lead">To purchase a Premium Alarm Pack, select the "Premium" tab in the "Alarms &amp; Timers" section of the Alexa app when choosing a tone for your alarm.</p>
                    </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-15">
                            <h4 class="mb-3 color-white">How do I select which Premium Alarm Tone plays?</h4>
                            <p>When a Premium Alarm pack is selected as your alarm tone, one of the tones will be played at random when your alarm activates.<br/>Amazon Alexa does not currently offer the ability to select a specific tone within the pack.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">Does Premium Membership include Premium Alarm Tones?</h4>
                            <p>No, Premium Alarm packs are sold separately from Premium Membership subscriptions.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">Can I download the alarms to use on other devices?</h4>
                            <p>No, our alarm tones are currently exclusive to Amazon Alexa devices. If you're a device manufacturer, please <router-link class="underline" to="/contact">contact us</router-link> for licensing opportunities.</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
export default {
    data () {
        return {
            "media": require('../assets/alarms.js'),
            "alarms_emit_config": {
                "pool": "alarms",
                "emitter": "alarms-stop"
            },
            "premium_alarms": [
                {
                    "id": "bird_beepbeep",
                    "name": "Beep Beep"
                },
                {
                    "id": "bird_digital",
                    "name": "Digital"
                },
                {
                    "id": "bird_sonar",
                    "name": "Sonar"
                },
                {
                    "id": "bird_iridescent",
                    "name": "Iridescent"
                },
                {
                    "id": "bird_luminary",
                    "name": "Luminary"
                },
                {
                    "id": "bird_radiant",
                    "name": "Radiant"
                },
                {
                    "id": "bird_synthbells",
                    "name": "Synth Bells"
                }
            ],
            "premium_alarms_emit_config": {
                "pool": "premium-alarms",
                "emitter": "premium-alarms-stop"
            }
        };
    },
    name: 'sounds',
    metaInfo: {
        title: 'Alarm Tones for Alexa',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Sleep Jar Alarm Tones help you wake up feeling refreshed with the peaceful sounds of nature.'
            }
        ]
    },
    methods: {
    },
    computed: {
    },
    components: {
    },
    mounted(){
        EventBus.$on(this.alarms_emit_config.emitter, function(key){
            var index = Object.keys(this.media).indexOf(key);
            console.log("Emitter received key:", key);
            console.log("Mapped to index:", index);
            this.$refs['alarm-previews'][index].stopAudio();
        }.bind(this));
        EventBus.$on(this.premium_alarms_emit_config.emitter, function(key){
            var index = this.premium_alarms.findIndex(function(item){
                return item.id == key;
            });
            console.log("Emitter received key:", key);
            console.log("Mapped to index:", index);
            this.$refs['premium-alarm-previews'][index].stopAudio();
        }.bind(this));
    }
}
</script>
